import { useState } from 'react'
import { authApi } from '../api/authApi'
import { accountOTPVerifySchema, zodErrorMessage, AccountOTPVerifyInput } from '@/shared/types'
import { notify } from '@/shared/utils'

interface UseVerifyOtpOptions {
  onSuccess: (token: string, redirectUrl: string) => void
}

export function useVerifyOtp({ onSuccess }: UseVerifyOtpOptions) {
  const [loading, setLoading] = useState(false)

  const verifyOtp = async (input: AccountOTPVerifyInput) => {
    if (loading) return

    const result = accountOTPVerifySchema.safeParse(input)
    if (!result.success) {
      notify.error(zodErrorMessage({ error: result.error }))
      return
    }

    try {
      setLoading(true)
      const response = await authApi.verifyOtp(result.data)
      notify.success(response?.message || 'OTP verified successfully')
      onSuccess(response?.data?.token, response?.data?.redirectUrl)
    } catch (error: unknown) {
      const err = error as { message?: string }
      notify.error(err?.message || 'Invalid OTP')
    } finally {
      setLoading(false)
    }
  }

  return { verifyOtp, loading }
}
